import { render, staticRenderFns } from "./attendanceRules.vue?vue&type=template&id=22752a2a&"
import script from "./attendanceRules.vue?vue&type=script&lang=js&"
export * from "./attendanceRules.vue?vue&type=script&lang=js&"
import style0 from "./attendanceRules.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "attendanceRules.vue"
export default component.exports